import { styled } from '@mui/material/styles'
import { useRouter } from 'next/router'
import { Container, Typography, Box, Divider, Stack, Button } from '@mui/material'
import Layout from '@/layouts/index'
import Page from '@/components/Page'
import { settingService, Section, GlobalSetting, SeoMetadata } from '@/services/page'
import pathService from '@/services/path'
import type { GetStaticPaths, GetStaticProps } from 'next'
import { APPS } from '@/appConfig'
import type { ParsedUrlQuery } from 'querystring'
import Iconify from '@/components/Iconify'
import { PATH_PAGE, PATH_ACCOUNT, PATH_APP_SERVICES } from '@/routes/paths'

interface PathProps extends ParsedUrlQuery {
  appId: string
}

interface IndexProps {
  title?: string
  sections?: Section[]
  globalSetting?: GlobalSetting
  seoMetadataItemsCollection?: SeoMetadata[]
}

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(8),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(11),
  },
}))

StripeSuccessPage.getLayout = function getLayout(page: React.ReactElement) {
  return <Layout variant="main">{page}</Layout>
}

export default function StripeSuccessPage({ title }: IndexProps) {
  const { push } = useRouter()

  return (
    <Page title="Success">
      <RootStyle>
        <Container>
          <Box sx={{ p: 4, maxWidth: 480, margin: 'auto' }}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h4" paragraph>
                Success
              </Typography>

              <Divider sx={{ my: 3 }} />

              <Typography align="left" sx={{ color: 'text.secondary' }}>
                Thank you for subscribing
                <br /> <br /> You can start enjoying services immediately
                <br /> <br /> If you have any question or queries then fell to get in contact us.{' '}
                <br /> <br /> All the best,
              </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Stack
              direction={{ xs: 'column-reverse', sm: 'row' }}
              justifyContent="space-between"
              spacing={2}
            >
              <Button
                color="inherit"
                onClick={() => push(PATH_ACCOUNT.service)}
                startIcon={<Iconify icon={'eva:arrow-ios-back-fill'} />}
              >
                Check Your Detail
              </Button>
              <Button
                color="inherit"
                onClick={() => push(PATH_APP_SERVICES.writer)}
                endIcon={<Iconify icon={'eva:arrow-ios-forward-fill'} />}
              >
                Continue Writer
              </Button>
            </Stack>
          </Box>
        </Container>
      </RootStyle>
    </Page>
  )
}

export const getStaticPaths: GetStaticPaths<PathProps> = async () => {
  const { getDefaultPaths } = pathService()
  const paths = APPS.flatMap((app) => getDefaultPaths(app.id))

  return {
    paths,
    fallback: true,
  }
}

export const getStaticProps: GetStaticProps<IndexProps, PathProps> = async ({ params, locale }) => {
  if (!params) throw new Error('No path parameters found')

  const { appId } = params

  const { getGlobalSetting } = settingService(appId)
  const globalSetting = await getGlobalSetting({ locale })

  return {
    props: {
      title: globalSetting.seoMetadataItemsMap.title,
      globalSetting,
    },
    revalidate: 3600,
  }
}
